// SEQ=10124 P8-CK-H — Spy UX 모달
// 사양: SEQ-10119 §3-3 #5 + SEQ-10123 §1-2 #5
//   ── 1단계: 상대 user 선택 (PlayerPick)
//   ── 2단계: 비공개 핸드 미리보기 + 카드 1장 선택 (SpyResultModal)
//
// 본 모달은 두 단계를 동일 컴포넌트가 step 분기로 표시.
// 비공개 핸드 데이터는 별도 invoke (catanHub.spyGetHand 가칭, 본 STEP=2에서는 자리표시자 props)
import { CatanPlayer } from '../../store/catan'

export interface SpyHandCard {
  cardId:   number
  cardType: string
}

export interface SpyHandModalProps {
  step: 'pick_player' | 'pick_card'
  /** 상대 후보 (본인 제외 active 플레이어) */
  candidatePlayers: CatanPlayer[]
  /** 선택된 상대 */
  targetUserCode?: number | null
  /** step=pick_card 도달 시 상대 손패 (Hub second-stage RPC 결과) */
  targetHand?: SpyHandCard[]
  /** 1단계 — 상대 선택 */
  onPickPlayer: (userCode: number) => void
  /** 2단계 — 가져올 카드 선택 → SignalR invoke */
  onPickCard:   (cardId: number) => void
  onCancel:     () => void
  busy?: boolean
}

export default function SpyHandModal({
  step, candidatePlayers, targetUserCode, targetHand,
  onPickPlayer, onPickCard, onCancel, busy,
}: SpyHandModalProps) {
  return (
    <div style={backdrop} onClick={busy ? undefined : onCancel}>
      <div style={card} onClick={e => e.stopPropagation()}>
        <h3 style={title}>🕵️‍♂️ 첩자 (Spy)</h3>
        {step === 'pick_player' ? (
          <div>
            <div style={body}>대상 플레이어를 선택하세요.</div>
            <ul style={list}>
              {candidatePlayers.map(p => (
                <li key={p.userCode} style={item}>
                  <button onClick={() => onPickPlayer(p.userCode)} disabled={busy} style={btnSec}>
                    {p.nickname}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div>
            <div style={body}>
              대상: <b>{candidatePlayers.find(p => p.userCode === targetUserCode)?.nickname}</b>
            </div>
            <div style={body}>가져올 진보카드 1장을 선택하세요.</div>
            {targetHand && targetHand.length > 0 ? (
              <ul style={list}>
                {targetHand.map(c => (
                  <li key={c.cardId} style={item}>
                    <button onClick={() => onPickCard(c.cardId)} disabled={busy} style={btnPri}>
                      {c.cardType} <span style={{ fontSize: 10, color: '#888' }}>(#{c.cardId})</span>
                    </button>
                  </li>
                ))}
              </ul>
            ) : (
              <div style={hint}>대상이 보유한 진보카드가 없습니다.</div>
            )}
          </div>
        )}
        <div style={footer}>
          <button onClick={onCancel} disabled={busy} style={btnSec}>취소</button>
        </div>
      </div>
    </div>
  )
}

const backdrop: React.CSSProperties = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }
const card:     React.CSSProperties = { background: '#fff', padding: 16, borderRadius: 6, minWidth: 320, maxWidth: 520, boxShadow: '0 4px 16px rgba(0,0,0,0.25)' }
const title:    React.CSSProperties = { margin: '0 0 10px 0', fontSize: 16 }
const body:     React.CSSProperties = { fontSize: 13, marginBottom: 8 }
const hint:     React.CSSProperties = { fontSize: 12, color: '#666', marginTop: 6 }
const list:     React.CSSProperties = { margin: '6px 0 0 0', padding: 0, listStyle: 'none' }
const item:     React.CSSProperties = { fontSize: 13, margin: '4px 0' }
const footer:   React.CSSProperties = { display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }
const btnPri:   React.CSSProperties = { padding: '4px 10px', background: '#1976D2', color: '#fff', border: 'none', borderRadius: 3, cursor: 'pointer' }
const btnSec:   React.CSSProperties = { padding: '4px 10px', background: '#eee', border: '1px solid #aaa', borderRadius: 3, cursor: 'pointer' }
